import { useState } from 'react';
import { 
  AppBar, 
  Toolbar, 
  Button, 
  Container, 
  Box, 
  IconButton, 
  Drawer, 
  List, 
  ListItem, 
  ListItemText,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { Menu as MenuIcon, Close as CloseIcon } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';

function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleAboutClick = () => {
    // Close mobile menu if open
    setMobileOpen(false);
    
    // If we're not on the home page, navigate to home first
    if (window.location.pathname !== '/') {
      window.location.href = '/#about-us-section';
    } else {
      // If we're on the home page, scroll to About Us section
      const element = document.getElementById('about-us-section');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleMobileNavClick = () => {
    setMobileOpen(false);
  };

  const drawer = (
    <Box sx={{ width: 250, bgcolor: '#1a1a1a', height: '100%', color: 'white' }}>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 1 }}>
        <IconButton onClick={handleDrawerToggle} sx={{ color: 'white' }}>
          <CloseIcon />
        </IconButton>
      </Box>
      <List>
        <ListItem button component={Link} to="/" onClick={handleMobileNavClick}>
          <ListItemText primary="Home" sx={{ color: 'white' }} />
        </ListItem>
        <ListItem button onClick={handleAboutClick}>
          <ListItemText primary="About" sx={{ color: 'white' }} />
        </ListItem>
        <ListItem button component={Link} to="/contact" onClick={handleMobileNavClick}>
          <ListItemText primary="Contact" sx={{ color: 'white' }} />
        </ListItem>
      </List>
    </Box>
  );

  return (
    <AppBar position="static" sx={{ bgcolor: '#1a1a1a' }}>
      <Container>
        <Toolbar sx={{ py: 1 }}>
          <Box component={Link} to="/" sx={{ display: 'flex', alignItems: 'center', flexGrow: 1, textDecoration: 'none' }}>
            <img src={logo} alt="Pierre Brothers Tech Logo" style={{ height: '70px', marginRight: '10px' }} />
          </Box>
          
          {isMobile ? (
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ color: 'white' }}
            >
              <MenuIcon />
            </IconButton>
          ) : (
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Button color="inherit" component={Link} to="/">Home</Button>
              <Button color="inherit" onClick={handleAboutClick}>About</Button>
              <Button color="inherit" component={Link} to="/contact">Contact</Button>
            </Box>
          )}
        </Toolbar>
      </Container>
      
      <Drawer
        variant="temporary"
        anchor="right"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          display: { xs: 'block', md: 'none' },
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: 250 },
        }}
      >
        {drawer}
      </Drawer>
    </AppBar>
  );
}

export default Header;
